import { SystemCode } from '@/api'
import {
  BibliographyFullIdWithMarcNo,
  BibliographyFullIdWithMarcNoToJSON
} from '@/types'

export interface BibliographySearchListDetailRequest {
  bibliographies: BibliographyFullIdWithMarcNo[]
  displayBranchCode: SystemCode
}

export function BibliographySearchListDetailRequestToJSON(
  value: BibliographySearchListDetailRequest
): any {
  return {
    bibliographies: value.bibliographies.map(
      BibliographyFullIdWithMarcNoToJSON
    ),
    display_branch_code: value.displayBranchCode.code ?? undefined
  }
}
